import "../../App.css";
import "../../styles/tabStyle.css";
import Sidebar from "../Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import AutocompleteForms from "../AutocompleteForms";
import React, { useState, useEffect } from "react";
import Parametros from "../Parametros";
import Table from "../Table";
import UserTab from "../UserTab";
import CrearCausa from "./CrearCausa";
import CurrentUser from "../CurrentUser";
import EmptyTableRow from "../EmptyTableRow";

function BusquedaCausas(props) {
  const [listaCausas, setListaCausas] = useState([]);
  // eslint-disable-next-line
  const [listaCausasUpdate, setListaCausasUpdate] = useState([]);
  const [buscarState, setBuscarState] = useState(true);
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  // eslint-disable-next-line
  const [update, setUpdate] = useState(false);
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  const [paginas, setPaginas] = useState(0);
  const [formularioUpdate, setformularioUpdate] = useState({});

  const [listTribunales, setTribunales] = useState([]);
  const [Empresa, setEmpresas] = useState([]);
  const [rolTribunal, setRolTribunal] = useState([]);
  const [deudores, setDeudores] = useState([]);
  // eslint-disable-next-line
  const [tipoState, setTipos] = useState([]);
  const [portfolios, setPortfolios] = useState([]);
  const [clients, setClients] = useState([]);
  const [states, setStates] = useState([]);
  const { history } = props;

  // Guard: si el usuario abrio directamente #/BusquedaCausas sin haber
  // logueado (bookmark, tab restaurado, redirect roto), CurrentUser.user()
  // devuelve null y todos los accesos a usuario.permisos / usuario.key
  // crashean con "Cannot read properties of null". Redirigimos al login.
  useEffect(() => {
    if (!usuario || !usuario.key) {
      history.push("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const defaultValue = { value: "", label: "Todos" };
  useEffect(() => {
    async function llamadaApi() {
      try {
        let responseDeudores = await fetch(Parametros.post + "debts", {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });
        let responseJsonDeudores = await responseDeudores.json();
        if (responseDeudores.status === 200 || responseDeudores.status === 201) {
          setDeudores(responseJsonDeudores);
        } else if (responseDeudores.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        }
      } catch (error) {
        console.error("Error al cargar deudores", error);
      }

      try {
        let responseTribunal = await fetch(Parametros.urlApi + "courts", {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });

        if (
          responseTribunal.status === 200 ||
          responseTribunal.status === 201
        ) {
          let responseJsonTribunal = await responseTribunal.json();
          setTribunales(responseJsonTribunal);
        }

        let responseRolTribunal = await fetch(
          Parametros.urlApi + "court_roles?skip=0&limit=100",
          {
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
          }
        );
        if (
          responseRolTribunal.status === 200 ||
          responseRolTribunal.status === 201
        ) {
          let responseJsonRolTribunal = await responseRolTribunal.json();
          setRolTribunal(responseJsonRolTribunal);
        }

        let responseEmpresas = await fetch(Parametros.urlApi + "companies", {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });

        if (
          responseEmpresas.status === 200 ||
          responseEmpresas.status === 201
        ) {
          let responseJsonEmpresas = await responseEmpresas.json();
          setEmpresas(responseJsonEmpresas);
        }

        let responseTipo = await fetch(
          Parametros.urlApi + "process_types?skip=0&limit=100",
          {
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
          }
        );

        if (responseTipo.status === 200 || responseTipo.status === 201) {
          let responseJsonTipo = await responseTipo.json();
          setTipos(responseJsonTipo);
        }
      } catch {}
    }
    llamadaApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetch(Parametros.urlApi + "portfolios?skip=0&limit=1000", {
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Error al cargar carteras");
        return res.json();
      })
      .then((data) => setPortfolios(data))
      .catch((error) => console.error(error));

    fetch(Parametros.urlApi + "clients", {
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Error al cargar clientes");
        return res.json();
      })
      .then((data) => setClients(data))
      .catch((error) => console.error(error));

    fetch(Parametros.urlApi + "states?is_mantenedor=false", {
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Error al cargar estados");
        return res.json();
      })
      .then((data) => setStates(data))
      .catch((error) => console.error(error));

    fetch(Parametros.urlApi + "stages?limit=5000&is_mantenedor=true", {
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
      },
    })
      .then((res) => (res.ok ? res.json() : { data: [] }))
      .then((d) => setEtapasList(Array.isArray(d?.data) ? d.data : []))
      .catch(() => setEtapasList([]));
  }, [usuario]);

  useEffect(() => {
    buscarCausa();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginacionState]);

  const [formularioBuscado, setFormularioBuscado] = useState({
    tipoCausa: "",
    tribunal: "",
    rolTribunal: "",
    empresa: "",
    rolDeudor: "",
    nOperacion: "",
    strategy: "",
    rol: "",
    portfolio: null,
    cliente: null,
    state: null,
    collProcId: null,
    etapa: null,
    rolExhorto: "",
  });
  const [etapasList, setEtapasList] = useState([]);

  const handleInputChange = (e, autocomplete) => {
    const value = e.target.value ? e.target.value : e.currentTarget.innerText;
    const name = e.target.getAttribute("name");

    setFormularioBuscado({
      ...formularioBuscado,
      [name]: value,
    });
  };

  let buscarCausa = async (event, fromButton = false) => {
    if (event) {
      event.preventDefault();
    }

    const formularioToSend = {
      ...formularioBuscado,
      empresa: formularioBuscado.empresa.split("-")[0],
      rit: formularioBuscado.rolTribunal,
    };

    //
    let skip;
    if (fromButton) {
      skip = 1;
      setPaginacionState({ ...paginacionState, skip: 1 });
      setUpdate(!update);
    } else {
      skip = paginacionState.skip;
    }

    let response = await fetch(
      `${Parametros.post}coll_process?skip=${skip}&limit=${paginacionState.limit}`,
      {
        method: "POST",

        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
        body: JSON.stringify(formularioToSend),
      }
    );
    let responseJSON = await response.json();
    if (response.status === 200 || response.status === 201) {
      setListaCausas(responseJSON.data);
      setListaCausasUpdate(responseJSON.data);

      // setPaginas(responseJson.n_pages)
      setPaginas(responseJSON.n_pages);
      setBuscarState(true);
    } else {
      alert(responseJSON.detail);
    }
  };

  let administrarCausa = (item) => {
    localStorage.setItem("item", JSON.stringify(item));
    history.push({
      pathname: `/AdministracionCausas/${item.coll_proc_id}`,
    });
  };

  const [exportingExcel, setExportingExcel] = useState(false);
  const exportarExcel = async () => {
    const formularioToSend = {
      ...formularioBuscado,
      empresa: formularioBuscado.empresa.split("-")[0],
      rit: formularioBuscado.rolTribunal,
    };
    setExportingExcel(true);
    try {
      const res = await fetch(`${Parametros.post}coll_process/excel`, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formularioToSend),
      });
      if (!res.ok) {
        const detail = await res.text();
        alert(detail || "Error al exportar a Excel");
        return;
      }
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const today = new Date().toISOString().slice(0, 10).replace(/-/g, "");
      // resumencausas_<estado>_<fecha>.xlsx — si no hay filtro de estado,
      // se omite el segmento intermedio (queda resumencausas_<fecha>).
      const stateName = states.find(
        (s) => s.state_id === formularioBuscado.state
      )?.name;
      const stateSlug = stateName
        ? stateName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")
        : "";
      link.href = url;
      link.download = stateSlug
        ? `resumencausas_${stateSlug}_${today}.xlsx`
        : `resumencausas_${today}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
      alert("Error de red al exportar a Excel");
    } finally {
      setExportingExcel(false);
    }
  };

  const [modalState, setModalState] = useState(false);

  let ModalConfig = () => {
    setModalState(!modalState);
  };

  // Sin sesion no renderizamos el JSX que depende de usuario.permisos.
  // El useEffect de arriba se ocupo del redirect a "/", pero como corre
  // despues del primer render este early-return evita el crash inicial.
  if (!usuario || !usuario.permisos) {
    return null;
  }

  return (
    <div className="App">
      <CrearCausa
        modalCondig={ModalConfig}
        tipoState={tipoState}
        courtRole={rolTribunal}
        acreedores={Empresa}
        deudores={deudores}
        listTribunales={listTribunales}
        setModal={setModalState}
        modalState={modalState}
      ></CrearCausa>

      <Sidebar tipo="1"></Sidebar>
      <br />
      <UserTab nombre={"Búsqueda de Causas"}></UserTab>
      {formularioBuscado && (
        <form id="formularioBusqueda" className="container">
          <div className="col-md-12">
            <div className="col-md-3">
              <h5>Cliente</h5>
              <AutocompleteForms
                personalHandleChange={handleInputChange}
                nameElement={"cliente"}
                formularioBuscado={formularioBuscado}
                setformulario={(nuevo) => {
                  setFormularioBuscado({ ...nuevo, etapa: null });
                }}
                key={update}
                value={formularioBuscado.cliente}
                suggestions={[
                  { label: "Todos", value: null },
                  ...clients.map((item) => {
                    return { value: item.client_id, label: item.name };
                  }),
                ]}
              />
            </div>
            <div className="col-md-3">
              <h5>N° Operación</h5>
              <input
                onChange={handleInputChange}
                name={"nOperacion"}
                className="form-control"
              ></input>
            </div>
            <div className="col-md-3">
              <h5>Estado</h5>
              <AutocompleteForms
                personalHandleChange={handleInputChange}
                nameElement={"state"}
                formularioBuscado={formularioBuscado}
                setformulario={setFormularioBuscado}
                key={update}
                value={formularioBuscado.state}
                suggestions={[
                  { label: "Todos", value: null },
                  ...states.map((item) => {
                    return { value: item.state_id, label: item.name };
                  }),
                ]}
              />
            </div>
            <div className="col-md-3">
              <h5>ID Cuenta</h5>
              <input
                type="number"
                onChange={(e) => {
                  const v = e.target.value;
                  setFormularioBuscado({
                    ...formularioBuscado,
                    collProcId: v === "" ? null : parseInt(v, 10),
                  });
                }}
                value={formularioBuscado.collProcId ?? ""}
                name="collProcId"
                className="form-control"
                placeholder="Ej: 1235"
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="col-md-3">
              <h5>Rut Deudor</h5>
              <input
                onChange={handleInputChange}
                name={"rolDeudor"}
                value={formularioBuscado.rolDeudor || ""}
                className="form-control"
                placeholder="Ej: 12345678-9"
              />
            </div>
            <div className="col-md-3">
              <h5>Rol</h5>
              <input
                onChange={handleInputChange}
                name={"rol"}
                value={formularioBuscado.rol || ""}
                className="form-control"
                placeholder="Ej: 1234-2025"
              />
            </div>
            <div className="col-md-3">
              <h5>Etapa</h5>
              {formularioBuscado.cliente == null ? (
                <input
                  className="form-control"
                  value=""
                  disabled
                  placeholder="Seleccioná un cliente primero"
                />
              ) : (
                <AutocompleteForms
                  personalHandleChange={handleInputChange}
                  nameElement={"etapa"}
                  formularioBuscado={formularioBuscado}
                  setformulario={setFormularioBuscado}
                  key={`${update}-${formularioBuscado.cliente}`}
                  value={formularioBuscado.etapa}
                  suggestions={[
                    { label: "Todas", value: null },
                    ...etapasList
                      .filter(
                        (e) => e.client_id === formularioBuscado.cliente
                      )
                      .map((e) => ({
                        value: e.stage_id,
                        label: e.name,
                      })),
                  ]}
                />
              )}
            </div>
            <div className="col-md-3">
              <h5>Rol Exhorto</h5>
              <input
                onChange={handleInputChange}
                name={"rolExhorto"}
                value={formularioBuscado.rolExhorto || ""}
                className="form-control"
                placeholder="N° del exhorto"
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="col-md-3">
              <br />
              <button
                type="button"
                onClick={(e) => {
                  buscarCausa(e, true);
                }}
                style={{ margin: "14px 0px" }}
                className="form-control button brEdit btn-primary"
              >
                Buscar
              </button>
            </div>
            <div className="col-md-3" style={{ marginBottom: "2em" }}>
              <br />
              <button
                style={{ margin: "14px 0px" }}
                type="button"
                onClick={() => {
                  setModalState(true);
                }}
                className="form-control button brEdit btn-primary"
              >
                Agregar
              </button>
            </div>
            <div className="col-md-3" style={{ marginBottom: "2em" }}>
              <br />
              <button
                style={{ margin: "14px 0px" }}
                type="button"
                onClick={exportarExcel}
                disabled={exportingExcel}
                className="form-control button brEdit btn-primary"
              >
                {exportingExcel ? "Exportando..." : "Exportar a Excel"}
              </button>
            </div>
          </div>
        </form>
      )}
      {buscarState && (
        <div className="busqueda-card-unico">
          <div className="busqueda-search-bar">
            <Table
              key={update}
              type={1}
              paginationBelow={true}
              paginas={paginas}
              paginadorState={paginacionState}
              setPaginadoor={setPaginacionState}
              elementos={[
                "N° Operación",
                "Deudor",
                "Rut Deudor",
                "Rol",
                "Tribunal",
                "ROL Exhorto",
                "Tribunal Exhorto",
                "Cliente",
                "Estado",
                "Gestión",
                "Comentario etapa",
              ]}
            ></Table>
          </div>
          <div className="large-table tabla-card-standalone">
            <table
              className="table table-bordered "
              id="myTable"
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <Table
                type={2}
                sinId={true}
                sinGestion={true}
                widths={[
                  "8%",
                  "12%",
                  "9%",
                  "9%",
                  "12%",
                  "9%",
                  "9%",
                  "10%",
                  "6%",
                  "5%",
                  "11%",
                ]}
                elementos={[
                  "N° Operación",
                  "Deudor",
                  "Rut Deudor",
                  "Rol",
                  "Tribunal",
                  "ROL Exhorto",
                  "Tribunal Exhorto",
                  "Cliente",
                  "Estado",
                  "Gestión",
                  "Comentario etapa",
                ]}
              ></Table>
              <tbody className="ajusteTabladata">
                {/* {usuario.modulos.indexOf("Causas") > -1 && usuario.permisos.indexOf("Ver") > -1 ? */}
                {usuario.permisos.indexOf("Ver") > -1 ? (
                  listaCausas.length === 0 ? (
                    <EmptyTableRow colSpan={11} />
                  ) : (
                    listaCausas.map((item, index) => {
                      const tdStyle = {
                        verticalAlign: "middle",
                        padding: "8px 10px",
                        fontSize: 13,
                      };
                      const tdCentered = { ...tdStyle, textAlign: "center" };
                      return (
                        <tr key={index}>
                          <td style={tdCentered}>{item.n_operation}</td>
                          <td style={tdStyle}>{item.nombre_deudor}</td>
                          <td style={tdCentered}>
                            {item.rut_deudor + "-" + item.rut_deudor_id}
                          </td>
                          <td style={tdCentered}>
                            {item.rol_tribunal + "-" + item.rol}
                          </td>
                          <td style={tdStyle}>{item.nombre_tribunal}</td>
                          <td style={tdCentered}>{item.rol_exhorto || "—"}</td>
                          <td style={tdCentered}>{item.tribunal_exhorto || "—"}</td>
                          <td style={tdStyle}>{item.cliente || "—"}</td>
                          <td
                            style={{
                              ...tdCentered,
                              backgroundColor: item?.state_colour,
                              fontWeight: 900,
                            }}
                          >
                            {item.state_name}
                          </td>
                          <td style={tdCentered}>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              onClick={() => administrarCausa(item)}
                            >
                              Ver
                            </button>
                          </td>
                          <td style={tdStyle}>{item.stage_comment || "—"}</td>
                        </tr>
                      );
                    })
                  )
                ) : (
                  <h1>no tiene permisos para ver las causa</h1>
                )}
              </tbody>
            </table>
          </div>
          <Table
            type={3}
            paginas={paginas}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
        </div>
      )}
    </div>
  );
}

export default withRouter(BusquedaCausas);
